import "zone.js";  // Included with Angular CLI.

import "core-js/modules/es.array.includes";
import "url-search-params-polyfill";
import regeneratorRuntime from "regenerator-runtime";

window["regeneratorRuntime"] = regeneratorRuntime;
